/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesInfoNewsNewsFromJSON, FxIdWebFeaturesInfoNewsNewsToJSON, } from './FxIdWebFeaturesInfoNewsNews';
/**
 * Check if a given object implements the FxIdWebFeaturesInfoNewsResponse interface.
 */
export function instanceOfFxIdWebFeaturesInfoNewsResponse(value) {
    if (!('News' in value) || value['News'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInfoNewsResponseFromJSON(json) {
    return FxIdWebFeaturesInfoNewsResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInfoNewsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'News': (json['News'].map(FxIdWebFeaturesInfoNewsNewsFromJSON)),
    };
}
export function FxIdWebFeaturesInfoNewsResponseToJSON(json) {
    return FxIdWebFeaturesInfoNewsResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesInfoNewsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'News': (value['News'].map(FxIdWebFeaturesInfoNewsNewsToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesInfoNewsResponse.js.map